<template>
  <div class="form-group row">
    <label :for="name" class="col-md-4 col-form-label text-md-right">
      <required-star v-if="required && showRequired"></required-star>
      {{ nameString }}
    </label>

    <div class="col-md-6">
      <input
        :id="name"
        :type="type || 'text'"
        :class="
          'form-control ' + (errors && name in errors ? 'is-invalid' : '')
        "
        :name="name"
        :pattern="pattern"
        :value="storedId ? storedId : name in old ? old[name] : ''"
        @blur="onBlur($event.target.value)"
        :autofocus="autofocus"
        :required="required"
        :minlength="minlength"
        :maxlength="maxlength || 255"
        :placeholder="placeholder"
      />
      <small v-if="hintText" class="form-text text-muted">{{ hintText }}</small>

      <span
        v-if="errors && name in errors"
        class="invalid-feedback"
        role="alert"
      >
        <strong v-for="error in errors[name]" v-bind:key="error">{{
          error
        }}</strong>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    nameString: String,
    type: String,
    errors: [Array, Object],
    old: [Array, Object],
    storedId: String,
    pattern: String,
    autofocus: Boolean,
    required: Boolean,
    showRequired: Boolean,
    hintText: String,
    minlength: String,
    maxlength: String,
    placeholder: String,
  },
  methods: {
    onBlur(value) {
      if (this.$listeners && this.$listeners.onBlurCallback) {
        this.$emit("onBlurCallback", value);
      }
      this.$emit("updateInputData", value);
    },
  },
};
</script>

